import { Table as MantineTable } from "@mantine/core";
import { CSSProperties, ReactNode } from "react";

interface TableProps {
  columns: string[];
  rows: ReactNode[][];
  eventClick?: (() => void)[];
  rowStyles?: (CSSProperties | undefined)[];
}

const Table = ({ ...props }: TableProps) => {
  return (
    <MantineTable>
      <MantineTable.Thead>
        <MantineTable.Tr>
          {(props?.columns ?? []).map(column => (
            <MantineTable.Th key={column}>{column}</MantineTable.Th>
          ))}
        </MantineTable.Tr>
      </MantineTable.Thead>
      <MantineTable.Tbody>
        {(props?.rows ?? []).map((row, rowIndex) => {
          return (
            <MantineTable.Tr key={rowIndex} style={props.rowStyles?.[rowIndex]}>
              {row.map((r, valueIndex) => {
                const rowClick = props.eventClick?.[rowIndex] || null;
                const hasEventClick =
                  (props?.eventClick ?? []).length >= rowIndex &&
                  typeof rowClick === "function";
                return (
                  <MantineTable.Td
                    key={valueIndex}
                    style={hasEventClick && { cursor: "pointer" }}
                    onClick={() => hasEventClick && rowClick()}
                  >
                    {r}
                  </MantineTable.Td>
                );
              })}
            </MantineTable.Tr>
          );
        })}
      </MantineTable.Tbody>
    </MantineTable>
  );
};

export default Table;
